export default {
    name: 'MenuBottom',
    props: ['sections']
};
